import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OffersComponent } from './containers/offers/offers.component';

const routes: Routes = [
  {
    children: [
      {
        component: OffersComponent,
        data: {
          toolbar: {
            title: 'Oferty',
          },
        },
        path: '',
      },
    ],
    path: '',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],
})
export class OffersRoutingModule {}
